import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'ottomanChipList',
    'ottomanInput',
    'ottomanHidden',
    'ottomanCount',
    'latinChipList',
    'latinInput',
    'latinHidden',
    'latinCount',
  ]

  connect() {
    this.initializeSortable(this.ottomanChipListTarget, 'ottoman')
    this.initializeSortable(this.latinChipListTarget, 'latin')
  }

  disconnect() {
    [this.ottomanChipListTarget, this.latinChipListTarget].forEach((chipListContainer) => {
      if (chipListContainer && $(chipListContainer).hasClass('ui-sortable')) {
        $(chipListContainer).sortable('destroy')
      }
    })
  }

  initializeSortable(chipListContainer, field) {
    // Map shared sortable setup to the hidden input Rails submits on save (comma-separated chip order).
    const hiddenCommaSeparatedValuesField = field === 'ottoman'
      ? this.ottomanHiddenTarget
      : this.latinHiddenTarget

    $(chipListContainer).sortable({
      items: '[data-legal-characters-chip]',
      tolerance: 'pointer',
      cancel: '.legal-characters-chips-remove, .legal-characters-chips-input, .legal-characters-chips-add',
      update: () => {
        hiddenCommaSeparatedValuesField.value = [...chipListContainer.querySelectorAll('[data-legal-characters-chip]')]
          .map((chipElement) => chipElement.dataset.legalCharactersChip).join(', ')
      },
    })
  }

  add(event) {
    event?.preventDefault()

    const field = event.currentTarget.dataset.field
    if (!field) return

    const isOttoman = field === 'ottoman'
    const chipListContainer = isOttoman ? this.ottomanChipListTarget : this.latinChipListTarget
    const inputField = isOttoman ? this.ottomanInputTarget : this.latinInputTarget
    const hiddenCommaSeparatedValuesField = isOttoman ? this.ottomanHiddenTarget : this.latinHiddenTarget

    if (!inputField.value) return

    for (const character of Array.from(inputField.value)) {
      const characterExists = [...chipListContainer.querySelectorAll('[data-legal-characters-chip]')].some(
        (chipElement) => chipElement.dataset.legalCharactersChip === character,
      )

      if (!characterExists) {
        inputField.insertAdjacentHTML(
          'beforebegin',
          `<span class="legal-characters-chips-chip d-inline-flex align-items-center overflow-hidden" data-legal-characters-chip="${character}">
            <span class="legal-characters-chips-glyph text-center${isOttoman ? ' legal-characters-chips-glyph-ottoman' : ''}"${isOttoman ? ' dir="rtl"' : ''}>${character}</span>
            <button type="button" class="legal-characters-chips-remove border-0 rounded-0 align-self-stretch" aria-label="Remove character" data-action="legal-characters-chips#remove">&times;</button>
          </span>`,
        )
      }
    }

    hiddenCommaSeparatedValuesField.value = [...chipListContainer.querySelectorAll('[data-legal-characters-chip]')]
      .map((chipElement) => chipElement.dataset.legalCharactersChip).join(', ')

    const characterCountElement = isOttoman ? this.ottomanCountTarget : this.latinCountTarget
    const characterCount = chipListContainer.querySelectorAll('[data-legal-characters-chip]').length
    characterCountElement.textContent = `${characterCount} characters`

    inputField.value = ''
    inputField.focus()
  }

  remove(event) {
    event.preventDefault()

    const chipElement = event.currentTarget.closest('[data-legal-characters-chip]')
    if (!chipElement) return

    const chipListContainer = chipElement.closest('.legal-characters-chips-box')
    const inputField = chipListContainer.querySelector('input[data-field]')
    const field = inputField?.dataset.field
    if (!field) return

    const isOttoman = field === 'ottoman'
    const hiddenCommaSeparatedValuesField = isOttoman ? this.ottomanHiddenTarget : this.latinHiddenTarget

    chipElement.remove()

    hiddenCommaSeparatedValuesField.value = [...chipListContainer.querySelectorAll('[data-legal-characters-chip]')]
      .map((chip) => chip.dataset.legalCharactersChip).join(', ')

    const characterCountElement = isOttoman ? this.ottomanCountTarget : this.latinCountTarget
    const characterCount = chipListContainer.querySelectorAll('[data-legal-characters-chip]').length
    characterCountElement.textContent = `${characterCount} characters`

    inputField.focus()
  }

  keydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.add(event)
    }
  }
}
